import { c as _c } from "react/compiler-runtime";
import type { ThemeFestival } from '@/app/(allowed)/festival/_utils/festivalFetchers';
import { FestivalCard } from '@/components/server';
import { ROUTES } from '@/constants';
import { FestivalCardSkeleton } from '../FestivalSearch/FestivalCardSkeleton';
import { HorizontalSlider } from './HorizontalSlider';
import { SectionHeader } from './SectionHeader';
const PREVIEW_SLIDER_COUNT = 5;
const SLIDE_CLASSNAME = 'max-w-220 flex-[0_0_calc((100%-24px)/2.5)] mobile:min-w-160';
export function FestivalPreviewSection(t0) {
  const $ = _c(13);
  const {
    keyword,
    items,
    totalCount,
    isLoading
  } = t0;
  if (!isLoading && items.length < 1) {
    return null;
  }
  const t1 = isLoading ? undefined : totalCount;
  let t2;
  if ($[0] !== keyword) {
    t2 = ROUTES.SEARCH.withSearchParams({
      searchParams: {
        q: keyword || undefined,
        category: "festival"
      }
    });
    $[0] = keyword;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <SectionHeader title={"\uB3D9\uB124\uCD95\uC81C"} totalCount={t1} moreHref={t2} />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isLoading || $[6] !== items) {
    t4 = isLoading ? Array.from({
      length: PREVIEW_SLIDER_COUNT
    }, _temp) : items.map(_temp2);
    $[5] = isLoading;
    $[6] = items;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <HorizontalSlider className="mobile-tablet:pl-20">{t4}</HorizontalSlider>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <section className="flex w-full flex-col">{t3}{t5}</section>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
function _temp2(festival, index_0) {
  return <div key={festival.id ?? index_0} className={SLIDE_CLASSNAME}><FestivalCard festival={festival} /></div>;
}
function _temp(_, index) {
  return <div key={index} className={SLIDE_CLASSNAME}><FestivalCardSkeleton /></div>;
}